// extracted by mini-css-extract-plugin
module.exports = {"commentsDrawer":"DocPage_commentsDrawer__3JuP3","viewing":"DocPage_viewing__1UOLn","gdocLink":"DocPage_gdocLink__4p1Ar","gdocThumbnail":"DocPage_gdocThumbnail__y0g-j"};